<template>

<div class="app">
    <template v-if="this.$store.state.settings.site_id == 1">

        <div class="container">
            <div class="contacts-sec__wrapper">
                <div class="contacts-sec__col1">
                    <div class="contacts-sec__element">
                        <p class="contacts-sec__title">{{ trans("Telephone") }}</p>
                        <a href="tel:+74997034020" class="contacts-sec__value">+7 (499) 703-40-20</a>
                    </div>
                    <div class="contacts-sec__element">
                        <p class="contacts-sec__title">{{ trans('Chart') }}</p>
                        <a v-if="false" class="contacts-sec__value" style="margin-bottom: 10px;">{{ trans("From December 31, 2025 to January 4, 2026 - CLOSED") }}</a>
                        <a class="contacts-sec__value">{{ trans("From January 5, 2026, UPDATED SCHEDULE: Mon-Fri from 10:00 to 19:00 Sat-Sun closed") }}</a>
                        <a v-if="false" class="contacts-sec__value"> {{trans("from 10 to 21 every day")}} </a>
                    </div>
                </div>
                <div class="contacts-sec__col2">
                    <div class="contacts-sec__element">
                        <p class="contacts-sec__title">{{trans("Mail (E-mail)")}}</p>
                        <a href="mailto:info@batnorton.com" class="contacts-sec__value"> info@batnorton.com </a>
                    </div>
                    <div class="contacts-sec__element">
                        <div class="contacts-sec__networks-row">
                            <Socials/>
                        </div>
                    </div>
                </div>
                <div class="contacts-sec__col3">
                    <div class="contacts-sec__element">
                        <p class="contacts-sec__title">{{trans("Collaboration (E-mail)")}}</p>
                        <a href="mailto:pr@batnorton.com" class="contacts-sec__value">pr@batnorton.com</a>
                    </div>
                </div>
            </div>
        </div>
        <Stores/>

    </template>
    <template v-if="this.$store.state.settings.site_id == 2">
        <main  class="main" >
            <section class="contacts-sec">
                <div class="container">
                    <div class="contacts-sec__wrapper">
                        <div class="">
                            <div class="contacts-sec__element">
                                <Socials :internationalContactsPage="true" />
                            </div>
                            <div class="contacts-sec__element">
                                <p class="contacts-sec__title">E-mail</p>
                                <a href="mailto:info@batnorton.com" class="contacts-sec__value">info@batnorton.com</a>
                            </div>
                            <div class="contacts-sec__element">
                                <p class="contacts-sec__title">Collaboration (E-mail)</p>
                                <a href="mailto:pr@batnorton.com" class="contacts-sec__value">pr@batnorton.com</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="store-info" class="store-body">
                <div class="container">

                    <div class="store-body__video-container">
                        <div class="about-brand-page__namer2-img">
                            <picture>
                                <source srcset="https://batnorton.com/img/181.webp" type="image/webp">
                                <img src="https://batnorton.com/img/181.webp" class="img-element" alt="">
                            </picture>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </template>

</div>
</template>

<script>
import Stores from '../Stores/index.vue'
import Socials from '@/src/components/Socials.vue';
export default {
    components:{
        Socials,
        Stores
    },
    name: "index"
}
</script>

<style scoped>

</style>
